/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ArtifactInterface, EduContentInterface, StorageInfoInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class ArtifactApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'Artifacts');
  }

  find(params?): Observable<ArtifactInterface[]> {
    const path = '';
    const httpParams = this._getHttpParams({ filter: params }, true);
    return this.get<ArtifactInterface[]>(path, httpParams);
  }

  create(artifact: ArtifactInterface): Observable<ArtifactInterface> {
    const path = '';
    return this.post<ArtifactInterface>(path, undefined, artifact);
  }

  patchAttributes(id: number, updates: Partial<ArtifactInterface>): Observable<ArtifactInterface> {
    const path = `${id}`;
    return this.patch<ArtifactInterface>(path, undefined, updates);
  }

  deleteById(id: number): Observable<boolean> {
    const path = `${id}`;
    return this.delete<boolean>(path, undefined);
  }

  store(artifactId: number, formData: FormData) {
    const path = `${artifactId}/store`;

    return this.post<{ storageInfo: StorageInfoInterface }>(path, undefined, formData);
  }

  uploadImage(artifactId: number, formData: FormData) {
    const path = `image/${artifactId}/upload`;

    return this.post<{ file: string; storageName: string }>(path, undefined, formData);
  }

  getInstructions(artifactId: number) {
    const path = `${artifactId}/instructions`;

    return this.get<{ name: string; video: EduContentInterface; text: EduContentInterface }>(path);
  }
}
